import { QUALIFICATION_STATUS } from '@/utils/constants';

const COLORS = {
  [QUALIFICATION_STATUS.OWNED]: '#4caf50',
  [QUALIFICATION_STATUS.OVERDUE]: '#f44336',
  [QUALIFICATION_STATUS.CURRENT]: '#00B050',
};

export default status => COLORS[status];